// Mobile Header Navigation Functionality

document.addEventListener('DOMContentLoaded', function() {
    // Clear search inputs on search results page
    // This ensures the input is cleared after form submission, even though
    // the Liquid template may populate it with search.terms
    if (window.location.pathname === '/search' || window.location.pathname.includes('/search?')) {
        const searchInput = document.querySelector('[data-search-input]');
        const mobileSearchInput = document.querySelector('[data-mobile-search-input]');
        
        if (searchInput) {
            searchInput.value = '';
        }
        if (mobileSearchInput) {
            mobileSearchInput.value = '';
        }
    }
    const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
    const mobileNavDrawer = document.querySelector('[data-mobile-nav-drawer]');
    const mobileNavLinks = document.querySelectorAll('[data-mobile-nav-expand]');
    const desktopNavToggles = document.querySelectorAll('[data-desktop-nav-toggle]');
    const header = document.getElementById('global-header');

    // Desktop Search Functionality
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchInputWrapper = document.querySelector('[data-search-input-wrapper]');
    const searchInput = document.querySelector('[data-search-input]');
    const searchClose = document.querySelector('[data-search-close]');
    const searchForm = document.querySelector('[data-search-form]');

    if (searchToggle && searchInputWrapper && searchInput) {
        // Clear input on form submit
        if (searchForm) {
            searchForm.addEventListener('submit', function(e) {
                // Clear the input immediately after form submission is triggered
                // This ensures the input is cleared even after page navigation
                if (searchInput.value.trim()) {
                    // Use requestAnimationFrame to clear after the form data is captured
                    requestAnimationFrame(() => {
                        searchInput.value = '';
                    });
                }
            });
        }

        // Toggle search input
        searchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = searchInputWrapper.classList.contains('is-open');
            
            if (isOpen) {
                // If already open, submit the form
                if (searchInput.value.trim()) {
                    searchForm.submit();
                }
            } else {
                // Open search
                searchInputWrapper.classList.add('is-open');
                searchToggle.setAttribute('aria-expanded', 'true');
                // Focus input after animation
                setTimeout(() => {
                    searchInput.focus();
                }, 100);
            }
        });

        // Close search
        if (searchClose) {
            searchClose.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeSearch();
            });
        }

        // Submit on Enter
        searchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (searchInput.value.trim()) {
                    searchForm.submit();
                }
            }
        });

        // Close search when clicking outside
        document.addEventListener('click', function(e) {
            if (searchInputWrapper.classList.contains('is-open')) {
                const searchItem = document.querySelector('.search-item');
                if (searchItem && !searchItem.contains(e.target)) {
                    closeSearch();
                }
            }
        });

        function closeSearch() {
            searchInputWrapper.classList.remove('is-open');
            searchToggle.setAttribute('aria-expanded', 'false');
            searchInput.value = '';
        }
    }

    // Mobile Search Functionality
    const mobileSearchToggle = document.querySelector('[data-mobile-search-toggle]');
    const mobileSearchInputWrapper = document.querySelector('[data-mobile-search-input-wrapper]');
    const mobileSearchInput = document.querySelector('[data-mobile-search-input]');
    const mobileSearchClose = document.querySelector('[data-mobile-search-close]');
    const mobileSearchForm = document.querySelector('[data-mobile-search-form]');

    if (mobileSearchToggle && mobileSearchInputWrapper && mobileSearchInput) {
        // Clear input on form submit
        if (mobileSearchForm) {
            mobileSearchForm.addEventListener('submit', function(e) {
                // Clear the input immediately after form submission is triggered
                // This ensures the input is cleared even after page navigation
                if (mobileSearchInput.value.trim()) {
                    // Use requestAnimationFrame to clear after the form data is captured
                    requestAnimationFrame(() => {
                        mobileSearchInput.value = '';
                    });
                }
            });
        }

        // Toggle search input
        mobileSearchToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = mobileSearchInputWrapper.classList.contains('is-open');
            
            if (isOpen) {
                // If already open, submit the form
                if (mobileSearchInput.value.trim()) {
                    mobileSearchForm.submit();
                }
            } else {
                // Open search
                mobileSearchInputWrapper.classList.add('is-open');
                mobileSearchToggle.setAttribute('aria-expanded', 'true');
                // Focus input after animation
                setTimeout(() => {
                    mobileSearchInput.focus();
                }, 100);
            }
        });

        // Close search
        if (mobileSearchClose) {
            mobileSearchClose.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                closeMobileSearch();
            });
        }

        // Submit on Enter
        mobileSearchInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                if (mobileSearchInput.value.trim()) {
                    mobileSearchForm.submit();
                }
            }
        });

        // Close search when clicking outside
        document.addEventListener('click', function(e) {
            if (mobileSearchInputWrapper.classList.contains('is-open')) {
                const mobileSearchItem = document.querySelector('.mobile-search-item');
                if (mobileSearchItem && !mobileSearchItem.contains(e.target)) {
                    closeMobileSearch();
                }
            }
        });

        function closeMobileSearch() {
            mobileSearchInputWrapper.classList.remove('is-open');
            mobileSearchToggle.setAttribute('aria-expanded', 'false');
            mobileSearchInput.value = '';
        }
    }

    // Toggle mobile menu drawer
    if (mobileMenuToggle && mobileNavDrawer) {
        mobileMenuToggle.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const isOpen = mobileNavDrawer.classList.contains('is-open');
            
            if (isOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
            if (mobileNavDrawer.classList.contains('is-open')) {
                if (!mobileNavDrawer.contains(e.target) && !mobileMenuToggle.contains(e.target)) {
                    closeMobileMenu();
                }
            }
        });

        // Close menu on escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileNavDrawer.classList.contains('is-open')) {
                closeMobileMenu();
            }
        });
    }

    function openMobileMenu() {
        if (mobileNavDrawer && mobileMenuToggle) {
            mobileNavDrawer.classList.add('is-open');
            mobileMenuToggle.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
        }
    }

    function closeMobileMenu() {
        if (mobileNavDrawer && mobileMenuToggle) {
            mobileNavDrawer.classList.remove('is-open');
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
            
            // Close all expanded nav items
            mobileNavLinks.forEach(link => {
                const expanded = link.closest('.mobile-nav-item').querySelector('[data-mobile-nav-expanded]');
                if (expanded) {
                    expanded.classList.remove('is-open');
                    link.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }

    // Handle expanded nav for each primary link
    // On mobile, links with expanded content should only toggle accordion, not navigate
    mobileNavLinks.forEach(link => {
        const expanded = link.closest('.mobile-nav-item').querySelector('[data-mobile-nav-expanded]');
        
        if (expanded) {
            // Prevent navigation and toggle accordion instead
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const isExpanded = expanded.classList.contains('is-open');
                
                // Close all other expanded items
                document.querySelectorAll('[data-mobile-nav-expanded]').forEach(item => {
                    if (item !== expanded) {
                        item.classList.remove('is-open');
                        const otherLink = item.closest('.mobile-nav-item').querySelector('[data-mobile-nav-expand]');
                        if (otherLink) {
                            otherLink.setAttribute('aria-expanded', 'false');
                        }
                    }
                });
                
                // Toggle current expanded item
                if (isExpanded) {
                    expanded.classList.remove('is-open');
                    link.setAttribute('aria-expanded', 'false');
                } else {
                    expanded.classList.add('is-open');
                    link.setAttribute('aria-expanded', 'true');
                }
            });
        }
    });

    // Desktop primary nav links should toggle dropdown, not navigate
    if (desktopNavToggles.length > 0 && header) {
        desktopNavToggles.forEach(link => {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                header.classList.toggle('is-expanded');
            });
        });

        document.addEventListener('click', function(e) {
            if (!header.contains(e.target)) {
                header.classList.remove('is-expanded');
            }
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                header.classList.remove('is-expanded');
            }
        });
    }
});

